(() => {
  const init = () => {
    const root = document.querySelector('#recent-reviews .jdgm-carousel-wrapper');
    if (!root) return;
    const track = root.querySelector('.jdgm-carousel__item-wrapper');
    const additionalReviews = document.querySelector('#sb-additional-home-reviews');
    if (track && additionalReviews) {
      const remaining = Math.max(0, 20 - track.querySelectorAll('.jdgm-carousel-item').length);
      Array.from(additionalReviews.content.children).slice(0, remaining).forEach(card => track.appendChild(card.cloneNode(true)));
    }
    const buttons = document.querySelectorAll('#recent-reviews [data-review-direction]');
    const updateControls = () => {
      if (!track) return;
      buttons.forEach(button => {
        button.disabled = Number(button.dataset.reviewDirection) < 0
          ? track.scrollLeft <= 2
          : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      });
    };
    if (track) {
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.jdgm-carousel-item');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({
          left: Number(button.dataset.reviewDirection) * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }));
      track.addEventListener('scroll', updateControls, { passive: true });
      new ResizeObserver(updateControls).observe(track);
    }
    const addLinks = () => {
      root.querySelectorAll('.jdgm-carousel-item__inner-wrapper').forEach(card => {
        if (card.querySelector('.sb-home-review-card-link')) return;
        const link = document.createElement('a');
        link.className = 'sb-home-review-card-link';
        link.href = '/pages/solution-based-product-reviews';
        link.setAttribute('aria-label', 'Read all customer reviews');
        link.addEventListener('click', event => event.stopPropagation());
        card.appendChild(link);
      });
    };
    addLinks();
    updateControls();
    new MutationObserver(addLinks).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
